// extracted by mini-css-extract-plugin
module.exports = {"container":"HowTo_container__3DB6h","label":"HowTo_label__22uAO","icon":"HowTo_icon__vB5uC"};